import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Project from 'pages/project/Project';

const ProjectRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Project />} />
    </Routes>
  );
};

export default ProjectRouter;
